import { GenericTable } from "../../components/table/GenericTable";
import { configComparatorType } from "../../types/types";
import { compareConfigJson, getConfigToCompare,getConfigToCompareInSameEnv} from "../../services/configComparatorService";
import { useCallback, useEffect, useState } from "react";
import { Box, Button, Icon, MenuItem, Modal, Stack } from "@mui/material";
import React from 'react'
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import { loader,DiffEditor } from '@monaco-editor/react';
import { GridColDef, GridRenderCellParams, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { openPopup } from "../../stateManagement/actions/popupActions";
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import ConfigCompareLogin from "./ConfigCompareLogin";
import { GenericInput } from "../../components/inputs/GenericInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck,faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import _ from "lodash";
import { getAccessToken } from "../../services/authenticationService";
loader.config({ monaco });

const iniheaders:GridColDef[] = [
  {
      "field": "configId",
      "headerName": "ID",
      "flex":1,
      "maxWidth": 350
  },
  {
      "field": "configName",
      "headerName": "Name",
      "flex":1,
      "maxWidth": 350
  },
  {
      "field": "description",
      "headerName": "Description",
      "flex":2,
      "maxWidth": 400
  },
  {
      "field": "activeStatus",
      "headerName": "Status",
      "flex":1,
      "maxWidth": 80
  }
]
const ModalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarDensitySelector />
      <GridToolbarColumnsButton/>
      {/* <GridToolbarFilterButton/> */}
      <Box margin={'auto'}></Box>
      <GridToolbarQuickFilter/>
    </GridToolbarContainer>
  );
}

function setHomeEnvToken() {
  const env = localStorage.getItem("env");
  const homeEnvToken = getAccessToken();
  if (env && homeEnvToken)
    EnvironmentRegistry.setToken(env, homeEnvToken);
}



const comparableEnvironments = () => Object.keys(EnvironmentRegistry.tokenRegistry).filter(env => EnvironmentRegistry.tokenRegistry[env].length > 0);

const isEnvAvailableToCompare = () => comparableEnvironments().length > 1;
const isLOBAvailableToCompare = ()=>{
  if(localStorage.getItem("compareLobAccessToken") && localStorage.getItem("compareLobName")){
    return true;
  }
  else{
    return false;
  }
}

export default function ConfigComparatorContainer () {
  
  const homeEnv = localStorage.getItem("env");
  const homeLob = localStorage.getItem("lob");
  const access_token = getAccessToken();

    
  const [open, setOpen] = useState<boolean>(false);
  
  const defaultEntity = "--none--";
  const defaultStatus = "all";

  const [selectedEntity,setSelectedEntity] = useState<string>(defaultEntity);
  const [selectedEnv,setSelectedEnv] = useState<string>("");
  const [compareLobName, setCompareLobName] = useState(localStorage.getItem("compareLobName") as string);
  const [compareLobAccessToken, setCompareLobAccessToken] = useState(localStorage.getItem("compareLobAccessToken") as string);
  const [status,setStatus] = useState<string>(defaultStatus);

  const availableConfigs:string[] = Object.keys(EnvironmentRegistry.configCmpRefUrlRegistry);
  
  const [configCompareArr,setConfigCompareArr] = useState<configComparatorType[]>([]);

  const [filter,setFilterValue] = useState<string>("");

  const toggleModal = ()=>{
    if(isEnvAvailableToCompare() || isLOBAvailableToCompare())
      setOpen(false) 
    else {
      openPopup('Alert', 'Please sign in into at least two LOBs or environments to compare');
      setOpen(false)
    }
  };
 
  
  useEffect(()=>{
    setHomeEnvToken();
    toggleModal();
  },[])
 


  const fetchDifferentOptionData = useCallback(async ()=>{
    if(selectedEntity === defaultEntity || !homeEnv) return;
    let configCompareMap = new Map<string, configComparatorType>();
    const homeEnvConfig = getConfigToCompare(homeEnv, selectedEntity,homeLob as string);
    const PromiseList = comparableEnvironments().filter(env=> env!== homeEnv).map(env => {
      return new Promise(resolve => {
        const envConfig = getConfigToCompare(env, selectedEntity, localStorage.getItem(`${env}lob`)as string);
        resolve(envConfig);
      }).then((envConfig) => {
        compareConfigJson(EnvironmentRegistry.getConfigRefAttr(selectedEntity),homeEnvConfig, homeEnv, envConfig, env, configCompareMap,selectedEntity);
      }).catch((err) => {
        openPopup('Error', err.message);
        console.error(err);
      })
    })
    Promise.all(PromiseList).then(() =>{
      setConfigCompareArr(Array.from(configCompareMap.values()));
    }).catch((err)=>console.error(err))
  },[selectedEntity,access_token,homeEnv])

  const fetchSameOptionData = useCallback(async ()=>{
    if(selectedEntity === defaultEntity || !homeEnv) return;
    let configCompareMap = new Map<string, configComparatorType>();
    const homeEnvConfig = await getConfigToCompareInSameEnv(homeEnv, selectedEntity,access_token as string,homeLob as string);
    const compareEnvConfig = await getConfigToCompareInSameEnv(homeEnv, selectedEntity, localStorage.getItem("compareLobAccessToken") as string, localStorage.getItem("compareLobName") as string);
    setCompareLobName(localStorage.getItem("compareLobName") as string);
   
    compareConfigJson(EnvironmentRegistry.getConfigRefAttr(selectedEntity),homeEnvConfig, homeLob as string, compareEnvConfig, localStorage.getItem("compareLobName") as string, configCompareMap,selectedEntity);
    setConfigCompareArr(Array.from(configCompareMap.values()));
  },[selectedEntity,access_token,homeEnv]);

  
  useEffect(() => {
    if(selectedEnv==homeEnv){
      fetchSameOptionData();
    }
    else{
      fetchDifferentOptionData();
    }
   
  }, [selectedEntity,compareLobAccessToken,compareLobName]);

 const filteredconfigCompareArr = filter.length > 0 
    ? configCompareArr.filter(config => String(config.configName).toLowerCase().startsWith(filter.toLowerCase()) || String(config.configId).toLowerCase().startsWith(filter.toLowerCase())) 
    : configCompareArr;

  return (
    <Stack m={4} spacing={4} className="configCompareRoot">
      <Button variant='contained' color="primary" onClick={() => setOpen(true)} >LoginForm</Button>
        <Modal open={open} onClose={toggleModal}>
          <Box className="config-compare-login-modal-container">
              <ConfigCompareLogin setSelectedEntity={()=>setSelectedEntity(defaultEntity)} setSelectedEnv={ setSelectedEnv} selectedEnv={ selectedEnv} />
          </Box>
        </Modal>
        <GenericInput
          textFieldInputProps={{
            fullWidth: true,
            select: true,
            label: "Configuration",
            value: selectedEntity,
            children: [defaultEntity,...availableConfigs].map((configOption) => (
              <MenuItem key={configOption} value={configOption}>
                {configOption}
              </MenuItem>
            )),
            onChange: (e) => setSelectedEntity(e.target.value),
          }}
        />
        <GenericInput
          textFieldInputProps={{
            fullWidth: true,
            label: "Filter Name",
            value: filter,
            onChange: (e) => setFilterValue(e.target.value),
          }}
        />
           <GenericInput
          textFieldInputProps={{
            fullWidth: true,
            select: true,
            label: "Status",
            value: status,
            children: ["all","invalid","success"].map((configOption) => (
              <MenuItem key={configOption} value={configOption}>
                {configOption}
              </MenuItem>
            )),
            onChange: (e) => setStatus(e.target.value),
          }}
        />
       
      {configCompareArr.length>0 && selectedEntity !== defaultEntity && <ConfigComparatorTable key={selectedEntity} configCompareArr={filteredconfigCompareArr.length > 0 ? filteredconfigCompareArr : configCompareArr} status={status} selectedEnv={selectedEnv} compareLobName={compareLobName}></ConfigComparatorTable>}
    </Stack>
  )

}



function ConfigComparatorTable( props:{configCompareArr:configComparatorType[],status:string,selectedEnv:string, compareLobName:string} ) {
  const {status} = props;
  const [rowJSONArr,setRowJSONArr] = useState<JSON[]>([]);
  const [headers,setHeaders] = useState<GridColDef[]>([]);
  const homeEnv = localStorage.getItem("env") || "";
  const homeLob = localStorage.getItem("lob") 
  const [selectedEnv,setSelectedEnv] = useState<string>("");
  const [open,setOpen] = useState(false);
  const [row,setRow] = useState<any>({});
  const[inline,setInline] = useState(true);

  
  const handleClick = useCallback((props: GridRenderCellParams) => {
    if (props.field === homeEnv) {
      openPopup("Alert", "selectedEnv is same as home env");
      return;
    }
    setSelectedEnv(props.field);
    setOpen(true);
    setRow(props.row);
    
  }, [setSelectedEnv, setOpen, setRow, homeEnv]);

  useEffect(() => {
    let rowJSONArr: JSON[] = [];
    let filteredRows= rowJSONArr;
    let headers = [...iniheaders];
    let configComparatorArr: configComparatorType[] = props.configCompareArr;
    let tmp = configComparatorArr[0];
    tmp.cmpDiff
      .forEach((element, key) => {
        let headerObj = Object.assign({}, headers[0]);
        headerObj.field = key;
        headerObj.headerName = key;
        headerObj.maxWidth = 100;
        headerObj.renderCell = (props:any)=>(
          <>
          <Button endIcon={props.value==="true" ? <FontAwesomeIcon icon={faCircleCheck} /> : <FontAwesomeIcon icon={faCircleXmark} />}  variant="contained" size="small" color={props.value==="true" ? "success" : "error"} title={String(props.value)} 
            sx={{
              pointerEvents : props.field === homeEnv ? "none" : "auto",
              fontSize: "12px",
              width:"10px",
            }}
            onClick={() => props.field === homeEnv ? undefined : handleClick(props)}></Button>
            
          </>
        )
        headerObj.valueGetter = (props)=> String(props.value);
        headers.push(headerObj);
      });
    configComparatorArr.forEach((configComparatorObj: configComparatorType) => {
      let row = JSON.parse(JSON.stringify(configComparatorObj.toString()));
      row.id = configComparatorObj.configId;
      configComparatorObj.cmpDiff
        .forEach((element, key) => {
          row[key] = element;
        });
      rowJSONArr = Object.assign([], rowJSONArr);
      rowJSONArr.push(row);
    });
    
    if(status==="invalid"){
       filteredRows=rowJSONArr.filter((row:any)=>{
        const cmpDiff = row.cmpDiff;
        if(cmpDiff && typeof cmpDiff==="object"){
          const values = Object.values(cmpDiff);
          return values.some((value:unknown)=>value===false);
        }
        return false;
      })
    }
    else if(status==="success"){
         filteredRows = rowJSONArr.filter((row:any)=>{
          const cmpDiff = row.cmpDiff;
          if(cmpDiff && typeof cmpDiff === "object"){
            const values = Object.values(cmpDiff);
            return values.every((value:unknown)=>!!value);
          }
          return false;
         })
    }
    else{
      filteredRows = rowJSONArr;
    }
    
   
    setRowJSONArr(filteredRows);
    
    setHeaders(headers);
  }, [handleClick, homeEnv, props.configCompareArr,status]);

  
  
  return (
    <Stack m={4} spacing={2}>
        <GenericTable
          disableColumnFilter
          // disableColumnMenu
          // disableColumnSelector
          disableRowSelectionOnClick
          // density="compact"
          autoHeight
          rows={rowJSONArr}
          columns={headers}
          slots={{
            toolbar: CustomToolbar,
          }}
          pageSizeOptions={[10, 20, 30, 40, 50, 80, 100]}
          initialState={{
            sorting: {
              sortModel: [{ field: "name", sort: "asc" }],
            },
            pagination: {
              paginationModel:{
                pageSize: 10,
              }
            },
          }}
          // hideFooterSelectedRowCount
        />
        {open && <Modal open={open} onClose={() =>{ setOpen(false); setSelectedEnv("")}}>
        <Stack sx={ModalStyle} spacing={2}>
          <Button fullWidth={false} sx={{width:"20px"}} onClick={()=>setInline(prev=>!prev)} variant="outlined" size="small"><Icon component={FormatLineSpacingIcon}></Icon></Button>
          {props.selectedEnv == homeEnv ? (
          <DiffEditor
          height="100%"
          language="javascript"
           originalLanguage="javascript"
    modifiedLanguage="javascript"
    options={{
      contextmenu: false,
      enableSplitViewResizing: inline, 
      renderSideBySide: inline, 
      renderValidationDecorations: 'off',
      readOnly: true,
      domReadOnly: true,
    }}
    original={JSON.stringify(row?.diff[homeLob as string], null, 2)}
    modified={JSON.stringify(row?.diff[props.compareLobName as string], null, 2)}
  />
) : (
 
  <DiffEditor
  height="100%"
  language="javascript"
  originalLanguage="javascript"
  modifiedLanguage="javascript"
  options={{
    contextmenu: false,
    enableSplitViewResizing: inline, 
    renderSideBySide: inline, 
    renderValidationDecorations: 'off',
    readOnly: true,
    domReadOnly: true,
  }}
  original={JSON.stringify(row?.diff[homeEnv], null, 2)}
  modified={JSON.stringify(row?.diff[selectedEnv], null, 2)}
/>
)}

        
        </Stack>
      </Modal>}
    </Stack>
  );
}